<ng-container [formGroup]="$any(subFormGroup.parent.root)">
  <div class="form-line-normal form-placeholder form-placeholder-small field-red">
    <input
      placeholder=" "
      [autocomplete]="isChrome ? 'off' : 'on'"
      spellcheck="false"
      type="text"
      id="booking_parameters_promotionCode"
      name="search_promotion_code"
      formControlName="promotionCode"
      class="form-input form-input-danger form-input-ext"
      (keyup)="searchPromocode($any($event.target).value)"
      (change)="searchPromocode($any($event.target).value)"
      [class.valid-input]="
        promotionCode.value?.length && promocodeState === PROMOCODE_VALID && !promocodeSearching
      "
      [class.invalid-input]="
        promotionCode.value?.length && promocodeState === PROMOCODE_INVALID && !promocodeSearching
      "
      [class.townpage]="!isIncludedOnStart"
      value="{{ promotionCode.value }}" />
    <label class="form-label form-label-red" for="booking_parameters_promotionCode">{{
      'ALPINSKIHIRE.shopSearch.formPromotionCode' | alpitranslate
    }}</label>
  </div>
  @if (bookingParameters.codes.length) {
    <div>
      @for (code of bookingParameters.codes; track code) {
        @if (code.type === 'couponcode') {
          <div class="row explainer">
            <div class="d-flex">
              <app-icon name="infoCircle" />
              <span>{{
                'ALPINSKIHIRE.shopSearch.promocode.couponCodeIsInCart' | alpitranslate: { code: code.text }
              }}</span>
            </div>
          </div>
        }
      }
    </div>
  }
</ng-container>
